import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';

export interface Category {
  id:string;

  }
  export interface Duration {
    set_id:string;

    }
  interface TokenResponse {
    token: string;
  }

@Injectable()
export class SectionService {
    private token: string;
    private headers = new HttpHeaders({
      'Content-Type': 'application/json'
   });
   private options = {
      headers: this.headers
   }
  constructor(private http: HttpClient) {}

  // /** GET heroes from the server */
  // getHeroes (): Observable<Hero[]> {
  //   return this.http.get<Hero[]>(this.heroesUrl)
  //     .pipe(
  //       catchError(this.handleError('getHeroes', []))
  //     );
  // }

  // // question category
  // public category(Category): Observable<any> {
  //   const base =  this.http.get<Category[]>('/users/category/');
  //
  //   const request = base.pipe(
  //     map((data: TokenResponse) => {
  //
  //
  //       return data;
  //     })
  //   );
  //   return request;
  // }


  // question category
  public category(user:Category): Observable<any> {
    const base =  this.http.post('/users/category/',user);

    const request = base.pipe(
      map((data: TokenResponse) => {


        return data;
      })
    );
    return request;
  }

  //Category Completion (new addition)
  public categoryCompletionTracker(userId:number): Observable<any> {
    const base =  this.http.get(`/users/category/sectioncompletion/${userId}`);

    const request = base.pipe(
      map((data: TokenResponse) => {
        return data;
      })
    );
    return request;
  }

  // question category
  public duration(user: Duration): Observable<any> {



    const base = this.http.post('/users/category/duration', user);

    const request = base.pipe(
      map((data: TokenResponse) => {


        return data;
      })
    );
    return request;
  }

}